<template>
    <!-- Dropdown menu -->
    <div
        v-if="event"
        ref="flotableDropdown"
        class="floatable-dropdown open"
        :style="styles"
        v-click-outside:mousedown="reset"
    >
        <slot />
    </div>
</template>

<script>
import ClickOutside from 'App/directives/clickOutside.js'
import IsClientMobile from 'App/components/mixins/IsClientMobile'

// Used when selecting in the corners so that users don't think there are more items not visible in the menu
const MarginOffsetY = 10
const MarginOffsetX = 20 // Margin X needs to be higher to account scrollbar width

export default {
    directives: {
        ClickOutside,
    },
    mixins: [
        IsClientMobile
    ],
    data () {
        return {
            width: 0,
            height: 0,
            event: null,
        }
    },

    methods: {
        reset () {
            this.event = null
        },

        open (event) {
            this.event = event
            this.$nextTick(() => {
                this.setWidgetDimensions()
            })
        },

        setWidgetDimensions () {
            const el = this.$refs.flotableDropdown
            this.width = el ? el.scrollWidth : 0
            this.height = el ? el.scrollHeight : 0
        },
    },

    computed: {
        eventPosition () {
            if (!this.event) {
                return null
            }

            // Case MouseEvent
            if (this.event.clientY && this.event.clientX) {
                return {
                    x: this.event.clientX,
                    y: this.event.clientY
                }
            // Case TouchEvent
            } else if (this.event.originalEvent.changedTouches.length) {
                const touchEvent = this.event.originalEvent.changedTouches[0]
                return {
                    x: touchEvent.clientX,
                    y: touchEvent.clientY
                }
            }

            return null
        },
        styles () {
            if (!this.eventPosition) {
                return {}
            }

            const baseStyles = {
                position: 'fixed',
                'z-index': 11,
            }

            // Check if dropdown will overlap with window height and adjust its position to accomodate that
            const top = this.eventPosition.y + this.height > window.innerHeight
                ? window.innerHeight - (this.height + MarginOffsetY)
                : this.eventPosition.y - (this.height / 2)

            if (this.isClientMobile) {
                return {
                    ...baseStyles,
                    top: `${top}px`,
                    left: '50%',
                    'margin-left': `-${this.width / 2}px` // Center dropdown in the middle of screen
                }
            }

            // Check if dropdown will overlap with window width and adjust its position to accomodate that
            const left = this.eventPosition.x + this.width > window.innerWidth
                ? window.innerWidth - (this.width + MarginOffsetX)
                : this.eventPosition.x

            return {
                ...baseStyles,
                top: `${top}px`,
                left: `${left}px`
            }
        }
    },
}
</script>
